import { useTranslation } from "react-i18next";
import { Label } from "@radix-ui/react-label";
import { EmailIcon } from "../settings-account/assets";

function EmailForm({ email }: { email: string }) {
  const { t } = useTranslation();
  return (
    <div className="space-y-2">
      <Label className="text-sm font-medium text-i-normal">
        {t("settings_account.email_form.email_address")}
      </Label>
      <div className="flex items-center gap-2">
        <EmailIcon className="text-[rgba(16,24,40,1)] w-5 h-5" />
        <p className="text-sm text-i-normal">
          {email}
        </p>
      </div>
    </div>
  );
}

export default EmailForm;